var map = {
	"./404-background.svg": 67147,
	"./about_bookshelf/icon-customer-reviews.svg": 62463,
	"./about_bookshelf/icon-institutions.svg": 33870,
	"./about_bookshelf/icon-pages-viewed.svg": 42107,
	"./about_bookshelf/icon-titles-available.svg": 74766,
	"./about_us/learn-save-computer.svg": 78834,
	"./about_us/returns.svg": 56816,
	"./about_us/safe_payments.svg": 22791,
	"./accessibility-icon.svg": 80115,
	"./account-center__button-icon.svg": 58102,
	"./act-ctr/act-ctr-circle_bookshelf.svg": 94611,
	"./act-ctr/act-ctr-circle_devices.svg": 39893,
	"./act-ctr/act-ctr-circle_purchases.svg": 69064,
	"./act-ctr/act-ctr-circle_settings.svg": 44736,
	"./act-ctr/act-ctr-circle_store.svg": 21281,
	"./act-ctr/act-ctr-circle_support.svg": 37486,
	"./act-ctr/act-ctr-circle_user_info.svg": 33803,
	"./backoffice/dashboard-admin-active.svg": 41075,
	"./backoffice/dashboard-admin.svg": 46422,
	"./backoffice/dashboard-admin_vst_manage-active.svg": 23805,
	"./backoffice/dashboard-admin_vst_manage.svg": 76118,
	"./backoffice/dashboard-currency_conversion_rates-active.svg": 49130,
	"./backoffice/dashboard-currency_conversion_rates.svg": 30004,
	"./backoffice/dashboard-directory_search-active.svg": 39689,
	"./backoffice/dashboard-directory_search.svg": 16696,
	"./backoffice/dashboard-email_configs-active.svg": 23853,
	"./backoffice/dashboard-email_configs.svg": 29625,
	"./backoffice/dashboard-email_logs-active.svg": 96135,
	"./backoffice/dashboard-email_logs.svg": 55668,
	"./backoffice/dashboard-features-active.svg": 3648,
	"./backoffice/dashboard-features.svg": 28704,
	"./backoffice/dashboard-ghost_inspector-active.svg": 82134,
	"./backoffice/dashboard-ghost_inspector.svg": 69987,
	"./backoffice/dashboard-guest_checkout-active.svg": 53381,
	"./backoffice/dashboard-guest_checkout.svg": 22511,
	"./backoffice/dashboard-imports-active.svg": 84233,
	"./backoffice/dashboard-imports.svg": 72511,
	"./backoffice/dashboard-promo_campaigns-active.svg": 12776,
	"./backoffice/dashboard-promo_campaigns.svg": 57530,
	"./backoffice/dashboard-queue-active.svg": 66204,
	"./backoffice/dashboard-queue.svg": 14856,
	"./backoffice/dashboard-search-active.svg": 13900,
	"./backoffice/dashboard-search.svg": 74252,
	"./black_square_icon.svg": 87702,
	"./bookmark_icon.svg": 19257,
	"./bookshelf-coach-me-logo.svg": 49616,
	"./bookshelf-coachme-logo.svg": 40438,
	"./bookshelf-icon-small.svg": 21454,
	"./bookshelf-icon.svg": 89128,
	"./bookshelflogo.svg": 3451,
	"./browser-not-supported.svg": 99670,
	"./bs-features-a11y-for-all.svg": 6252,
	"./bs-features-coach-me.svg": 34100,
	"./bs-features-custom-styles.svg": 17468,
	"./bs-features-global-search.svg": 33662,
	"./bs-features-inline-notes.svg": 62575,
	"./bs-features-read-aloud.svg": 27943,
	"./bs-features-read-on-the-go.svg": 17405,
	"./bs-features-sync-across-devices.svg": 32125,
	"./bs-features-workbook.svg": 45256,
	"./bs-laptop.svg": 44298,
	"./bs-mobile.svg": 1374,
	"./bs-tablet.svg": 29906,
	"./bulk-hp-accessibility.svg": 27463,
	"./bulk-hp-bookshelf.svg": 83399,
	"./bulk-hp-cart.svg": 68005,
	"./bulk-hp-checkout.svg": 46520,
	"./bulk-hp-download.svg": 84328,
	"./bulk-hp-find-books.svg": 75163,
	"./bulk-hp-redeem.svg": 80587,
	"./bulk-hp-reviews.svg": 97172,
	"./bulk-hp-save.svg": 95432,
	"./bulk-hp-support.svg": 49062,
	"./bulk-hp-titles.svg": 63319,
	"./callout.svg": 53460,
	"./carbon_neutrality/car-mobile.svg": 88594,
	"./carbon_neutrality/car.svg": 82726,
	"./carbon_neutrality/computer-mobile.svg": 68091,
	"./carbon_neutrality/computer.svg": 30371,
	"./carbon_neutrality/planet-smart-desktop.svg": 12322,
	"./carbon_neutrality/planet-smart-mobile.svg": 83944,
	"./carbon_neutrality/trees-mobile.svg": 80592,
	"./carbon_neutrality/trees.svg": 27746,
	"./caret-blue.svg": 95672,
	"./caret-branded.svg": 51856,
	"./caret-down-reusable.svg": 44579,
	"./caret-down-sm-ocean.svg": 97351,
	"./caret-down-sm.svg": 97357,
	"./caret-icon-black-down.svg": 24891,
	"./caret-icon-black-up.svg": 80896,
	"./caret-left.svg": 48263,
	"./caret-white.svg": 80651,
	"./cart-icon.svg": 5680,
	"./cart-white-icon.svg": 48034,
	"./chapters-available-badge.svg": 16057,
	"./chat-line.svg": 18320,
	"./chat.svg": 34558,
	"./checkmark-circle-green.svg": 66056,
	"./checkmark-circle.svg": 81058,
	"./checkmark-icon-green.svg": 8158,
	"./checkmark_icon.svg": 97099,
	"./circle-icon-small.svg": 43773,
	"./circle.svg": 58634,
	"./close-icon-black.svg": 72626,
	"./close-icon-red.svg": 85312,
	"./close-icon-white.svg": 90928,
	"./coach-me-build.svg": 61527,
	"./coach-me-checkmark.svg": 35045,
	"./coach-me-checkout-icon.svg": 39275,
	"./coach-me-focused.svg": 25317,
	"./coach-me-laptop-checkpoint.svg": 70037,
	"./coach-me-laptop.svg": 67030,
	"./coach-me-learn.svg": 27859,
	"./coach-me-look-for-icon.svg": 14266,
	"./coach-me-practice.svg": 11031,
	"./coach-me-prepare.svg": 28051,
	"./coach-me.svg": 85291,
	"./coachme-included.svg": 83876,
	"./college-icon.svg": 10217,
	"./copy-icon.svg": 48138,
	"./courseware-purchase.svg": 18873,
	"./courseware-read.svg": 54359,
	"./courseware-redeem.svg": 94521,
	"./courseware-visit.svg": 24494,
	"./customer-satisfaction-icon.svg": 21027,
	"./dashboard-icon.svg": 66927,
	"./dashboard-manage-active.svg": 52078,
	"./dashboard-manage.svg": 25084,
	"./digital-purchase-icon.svg": 6966,
	"./doodle_book_lovers.svg": 46618,
	"./download-icon-white.svg": 84311,
	"./ellipsis.svg": 84997,
	"./exclamation-black.svg": 48654,
	"./exclamation-circle-red.svg": 96017,
	"./exclamation-circle.svg": 53358,
	"./exclamation.svg": 39729,
	"./external-link-icon-black.svg": 97549,
	"./external-link-icon-blue.svg": 70917,
	"./external-link-icon-dark-grey.svg": 23596,
	"./external-link-icon-light-blue.svg": 89473,
	"./external-link-icon-white.svg": 71600,
	"./external-link-icon.svg": 78459,
	"./eye_closed.svg": 24997,
	"./eye_open.svg": 46017,
	"./facebook-icon.svg": 80786,
	"./facebook_icon.svg": 39580,
	"./facets-nested-icon.svg": 74531,
	"./fall-ebook-shopping.svg": 42530,
	"./features/anytime.svg": 77571,
	"./features/coachme.svg": 9111,
	"./features/flashcard_study.svg": 13075,
	"./features/global_search.svg": 42628,
	"./features/icon_global_search.svg": 72645,
	"./features/icon_offline_access.svg": 46326,
	"./features/icon_read_aloud.svg": 88293,
	"./features/icon_study_tools.svg": 15019,
	"./features/margin_notes.svg": 50421,
	"./features/read_aloud.svg": 97562,
	"./features/read_aloud_book.svg": 94314,
	"./features/reliability.svg": 34702,
	"./features/wikipedia_lookup.svg": 76432,
	"./features/workbook.svg": 28666,
	"./form-error-icon.svg": 87662,
	"./form-success-icon.svg": 12644,
	"./graphic-cloud.svg": 7310,
	"./graphic-inclusive-access.svg": 17618,
	"./graphic-read-anywhere.svg": 54110,
	"./graphic-save-money.svg": 53200,
	"./graphic-save-trees.svg": 82133,
	"./graphic-smart.svg": 82480,
	"./graphic-tablet.svg": 93699,
	"./graphic-tress.svg": 68502,
	"./graphic-unified-reading.svg": 2107,
	"./icon-caret-right.svg": 34841,
	"./icon-circle-error.svg": 85784,
	"./icon-download.svg": 95413,
	"./icon-globe.svg": 84925,
	"./icon-group.svg": 11287,
	"./icon-happy-face.svg": 57966,
	"./icon-print.svg": 64705,
	"./icon-return-ocean-rtl.svg": 85207,
	"./icon-return-ocean.svg": 59233,
	"./icon-return-white.svg": 94351,
	"./icon-return.svg": 82734,
	"./icon-search.svg": 7085,
	"./icon-small-return-ocean.svg": 74386,
	"./icon_radio_selected.svg": 25856,
	"./inclusive-access-badge.svg": 63386,
	"./incorrect-product.svg": 29774,
	"./info-compromised.svg": 86522,
	"./info-icon.svg": 77174,
	"./info-tooltip-icon.svg": 46603,
	"./info.svg": 75020,
	"./instagram-icon.svg": 51222,
	"./instant-access.svg": 56175,
	"./institution_admin_hub/adopt.svg": 62778,
	"./institution_admin_hub/bookstore.svg": 72607,
	"./institution_admin_hub/help.svg": 25615,
	"./institution_admin_hub/report.svg": 87925,
	"./institution_admin_hub/voucher.svg": 15568,
	"./instructor-resource-badge.svg": 81179,
	"./linkedin-icon.svg": 57642,
	"./logo_bookshelf.svg": 52829,
	"./mail_icon.svg": 11247,
	"./online-resource-register-disabled-icon.svg": 7838,
	"./online-resource-register-icon.svg": 6020,
	"./online-resource-reveal-disabled-icon.svg": 26629,
	"./online-resource-reveal-icon.svg": 95644,
	"./online-resource-visit-disabled-icon.svg": 70502,
	"./online-resource-visit-icon.svg": 17769,
	"./payment-card-icon.svg": 28282,
	"./payment_icons/amex.svg": 95531,
	"./payment_icons/apple-pay.svg": 18758,
	"./payment_icons/discover.svg": 64459,
	"./payment_icons/mastercard.svg": 67188,
	"./payment_icons/paypal.svg": 95379,
	"./payment_icons/visa.svg": 58106,
	"./pdp-features__epub--active.svg": 96190,
	"./pdp-features__read-anywhere--active.svg": 60345,
	"./pdp-features__studytools--active.svg": 84804,
	"./pdp-inclusive-access.svg": 22270,
	"./play.svg": 71048,
	"./print_icon.svg": 69334,
	"./purchase.svg": 99208,
	"./quotations-icon.svg": 50200,
	"./read-offline.svg": 6637,
	"./read-only-chat.svg": 89257,
	"./read.svg": 66365,
	"./red-flag.svg": 7212,
	"./redeem.svg": 30467,
	"./redirect-spinner.svg": 66558,
	"./regions_flags/flag-ar-rectangular.svg": 45751,
	"./regions_flags/flag-au-circular-small.svg": 13405,
	"./regions_flags/flag-au-rectangular.svg": 45107,
	"./regions_flags/flag-ca-circular-small.svg": 48444,
	"./regions_flags/flag-ca-rectangular.svg": 78480,
	"./regions_flags/flag-de-circular-small.svg": 65978,
	"./regions_flags/flag-de-rectangular.svg": 31517,
	"./regions_flags/flag-es-rectangular.svg": 62787,
	"./regions_flags/flag-ie-circular-small.svg": 50313,
	"./regions_flags/flag-ie-rectangular.svg": 32560,
	"./regions_flags/flag-in-rectangular.svg": 94730,
	"./regions_flags/flag-it-rectangular.svg": 85372,
	"./regions_flags/flag-jp-rectangular.svg": 6887,
	"./regions_flags/flag-mx-rectangular.svg": 17531,
	"./regions_flags/flag-nl-rectangular.svg": 7344,
	"./regions_flags/flag-nz-rectangular.svg": 93470,
	"./regions_flags/flag-pe-rectangular.svg": 41439,
	"./regions_flags/flag-sa-rectangular.svg": 26345,
	"./regions_flags/flag-sg-rectangular.svg": 44191,
	"./regions_flags/flag-uk-circular-small.svg": 75056,
	"./regions_flags/flag-uk-rectangular.svg": 83586,
	"./regions_flags/flag-us-ca-circular-small.svg": 99411,
	"./regions_flags/flag-us-circular-small.svg": 64828,
	"./regions_flags/flag-us-rectangular.svg": 2956,
	"./regions_flags/flag-za-circular-small.svg": 55453,
	"./regions_flags/flag-za-rectangular.svg": 80564,
	"./request-form.svg": 16938,
	"./select-caret-icon.svg": 23368,
	"./share_icon.svg": 45959,
	"./signin-card-icon.svg": 92799,
	"./star-half-navy.svg": 75543,
	"./star-half-orange.svg": 18267,
	"./star-half-white.svg": 32082,
	"./star-whole-navy.svg": 92009,
	"./star-whole-orange.svg": 49962,
	"./star-whole-white.svg": 80721,
	"./student-hp-convenient-grey.svg": 40709,
	"./student-hp-convenient.svg": 23264,
	"./student-hp-fast-grey.svg": 24090,
	"./student-hp-fast.svg": 61270,
	"./student-hp-smart-grey.svg": 54450,
	"./student-hp-smart.svg": 13941,
	"./studytool.svg": 85829,
	"./support-icon-small.svg": 27714,
	"./tooltip_icon.svg": 75108,
	"./trash-icon-magic.svg": 29346,
	"./tts.svg": 8878,
	"./virus.svg": 49755,
	"./vitalsource-logo.svg": 60165,
	"./vitalsource-white-logo.svg": 70394,
	"./vst-bookshelf-logo.svg": 82187,
	"./warning.svg": 45750,
	"./watkins-laptop-no.svg": 50161,
	"./watkins-laptop.svg": 41806,
	"./watkins-student-error.svg": 46310,
	"./watkins-student.svg": 78718,
	"./watkins-thinking.svg": 13607,
	"./watkins.svg": 13208,
	"./watkins_balloon_happy.svg": 77694,
	"./watkins_read_now_bookshelf.svg": 88361,
	"./watkins_register_scribbles.svg": 47504,
	"./watkins_sign_in.svg": 44118,
	"./watkins_welcome.svg": 7585,
	"./why-buy-accessibility.svg": 4641,
	"./why-buy-download.svg": 44574,
	"./why-buy-savings.svg": 44215,
	"./why-buy-titles.svg": 95246,
	"./wls/logo/uccs-logo.svg": 10330,
	"./wls/logo/university-prep-logo.svg": 73258,
	"./x-icon.svg": 20620,
	"./youtube-icon.svg": 24965,
	"./zendesk-question-mark.svg": 4951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15590;